// extracted by mini-css-extract-plugin
export default {"layout":"LoginLayout_layout__qvsOo","main":"LoginLayout_main__TzE2B","container":"LoginLayout_container__CTOjI","footer":"LoginLayout_footer__AkdG+"};